import { FormControlLabel, Grid, styled } from '@mui/material';
import { COLORS } from '../../theme/color';
import { maxWidth } from '../../theme/theme';

export const Container = styled('div')`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #f8f7f7;
  position: relative;
`;

export const MobileHeading = styled('div')`
  display: none;
  width: 100%;
  max-width: ${maxWidth}px;
  margin: 0 auto;
  background: #fff;
  padding: 16px;
  margin-bottom: 0;

  h2 {
    font-weight: 600;
    font-size: 24px;
    margin: 0;
    color: #000;
  }

  @media (max-width: 600px) {
    display: block;
  }
`;

export const MainGridCon = styled(Grid)`
  width: 100%;
  // max-width: ${maxWidth}px;
  margin: auto;
  padding: 0 1rem;
  justify-content: space-between;
  flex-wrap: wrap-reverse;

  @media (max-width: 600px) {
    padding: 0 0rem;
  }
`;

export const CheckoutContainer = styled('div')`
  width: 100%;
  min-height: 400px;
  background: #fff;
  padding: 40px;
  @media (max-width: 600px) {
    padding: 10px;
  }

  h3 {
    font-weight: 600;
    font-size: 24px;
    margin-bottom: 24px;

    @media (max-width: 600px) {
      font-size: 20px;
      margin-bottom: 16px;
    }
  }

  h2 {
    font-weight: 600;
    font-size: 32px;
    margin: 24px 0 8px 0;

    @media (max-width: 600px) {
      font-size: 24px;
      margin: 16px 0 6px 0;
    }
  }

  .desktop-heading {
    font-weight: 600;
    font-size: 32px;
    margin: 24px 0 8px 0;

    @media (max-width: 600px) {
      display: none; /* Hide on mobile */
    }
  }

  p {
    line-height: 24px;

    @media (max-width: 600px) {
      line-height: 20px;
    }
  }

  p.top {
    margin-bottom: 35px;

    @media (max-width: 600px) {
      margin-bottom: 24px;
    }
  }

  p,
  label {
    color: #483d3d;
    font-size: 14px;

    @media (max-width: 600px) {
      font-size: 13px;
    }
  }

  .sub-head,
  .name,
  .edit {
    font-weight: 700;
    color: ${COLORS.MainBlack};
  }

  .sub-head {
    font-size: 16px;
    margin: 16px 0;
    &:nth-of-type(2),
    &:nth-of-type(4) {
      margin: 0;
    }

    @media (max-width: 600px) {
      font-size: 14px;
      margin: 12px 0;
    }
  }

  .contact-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .edit {
      height: max-content;
      display: flex;
      align-items: center;
      p {
        margin-left: 10px;
      }
      &:hover,
      &:hover p {
        color: ${COLORS.MainBlue};
      }
      cursor: pointer;
    }
    .name {
      display: flex;
      word-spacing: 3px;
      gap: 10px;
    }
  }
  .note {
    margin-top: 24px;
    p {
      margin-bottom: 8px;
      font-weight: 700;
      color: #180101;
    }
    textarea {
      width: 100%;
      min-height: 80px;
      outline: none;
      font-size: 14px;
      padding: 16px;
      margin-bottom: 35px;
      border: 1px solid #00000040;
      &:focus {
        outline: none;
      }

      @media (max-width: 600px) {
        padding: 12px;
        font-size: 13px;
        min-height: 60px;
      }
    }
  }

  button {
    font-weight: 700;
    word-spacing: 5px;

    @media (max-width: 600px) {
      width: 100%;
    }
  }
`;

export const CheckoutItems = styled('div')`
  width: 100%;
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  h3 {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    color: ${COLORS.MainBlack};
  }

  @media (max-width: 767px) {
    padding: 16px;
    border-radius: 0;
    box-shadow: none;
    border-bottom: 1px solid #e8e8e8;
  }
`;

export const PriceSummary = styled('div')`
  width: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-top: 0px;
  overflow: hidden;

  div {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${COLORS.MainBlack};
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #f8f9fa;
    }

    p:nth-of-type(2) {
      font-size: 18px;
      line-height: 23px;
      font-weight: 500;
    }
  }

  .subtotal {
    border-top: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
  }

  .delivery {
    border-bottom: 1px solid #e8e8e8;
  }

  .total {
    p:nth-of-type(2) {
      font-weight: 600;
      color: #1a1a1a;
    }
  }

  .wallet {
    p:nth-of-type(2) {
      font-size: 16px;
      line-height: 20px;
      color: ${COLORS.MainBlue};
    }

    .wallet-point {
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: color 0.2s ease;

      &:hover {
        color: ${COLORS.MainBlue};
      }
    }

    .wallet-text {
      margin-left: 10px;
    }
  }

  .grandtotal {
    border-top: 2px solid #e8e8e8;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);

    p {
      font-weight: 700;
      font-size: 18px;
      color: #1a1a1a;
    }
  }

  @media (max-width: 767px) {
    border-radius: 0;
    box-shadow: none;
    margin-top: 0px;

    div {
      padding: 0 16px;
      font-size: 15px;

      p:nth-of-type(2) {
        font-size: 16px;
      }
    }

    .grandtotal {
      p {
        font-size: 16px;
      }
    }
  }
`;

export const LogisticsCon = styled('div')`
  padding: 20px 40px;
`;

export const StyledLogisticFormLabel = styled(FormControlLabel)(({ checked }) => ({
  '.MuiFormControlLabel-label': checked
    ? {
        fontWeight: 500
      }
    : {
        color: '#6F6F6F',
        fontSize: '14px'
      },
  '.MuiSvgIcon-root': checked
    ? {
        color: COLORS.MainBlue
      }
    : {
        color: '#6F6F6F'
      }
}));
